class PopupMessage {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.overlay = wrapper.querySelector('.popup-message-overlay');
    this.closeButton = wrapper.querySelector('.popup-message-close');
    this.container = wrapper.querySelector('.popup-message-container');

    this.delay = 3000;
    this.storageKey = 'hasVisitedLoomstatePopOver';
    this.checkParameter = wrapper.dataset.checkUrlParameter === 'true';
    this.expectedRefValue = wrapper.dataset.refValue || 'partner';
    this.manual = wrapper.dataset.manual === 'true';

    this.init();
  }

  init() {
    this.setupEventListeners();

    if (!this.manual && this.shouldShowInitialPopup()) {
      this.scheduleShow();
    }
  }

  shouldShowInitialPopup() {
    const hasVisited = localStorage.getItem(this.storageKey);
    let cameFromPartner = false;

    if (this.checkParameter) {
      cameFromPartner = this.hasMatchingRefParameter();
    }

    return cameFromPartner ? true : hasVisited ? false : true;
  }

  hasMatchingRefParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const refValue = urlParams.get('ref');

    return refValue === this.expectedRefValue;
  }

  scheduleShow() {
    setTimeout(() => {
      this.show();
    }, this.delay);
  }

  show() {
    this.wrapper.classList.add('active');
    document.body.classList.add('popup-open');

    this.wrapper.offsetHeight;

    requestAnimationFrame(() => {
      this.wrapper.classList.add('visible');
    });

    setTimeout(() => {
      if (this.closeButton) this.closeButton.focus();
    }, 300);
  }

  hide() {
    this.wrapper.classList.remove('visible');

    setTimeout(() => {
      this.wrapper.classList.remove('active');
      document.body.classList.remove('popup-open');
    }, 300);
  }

  confirm() {
    localStorage.setItem(this.storageKey, 'true');
    this.hide();
  }

  setupEventListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.hide();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.hide();
      });
    }

    const cancelButtons = this.wrapper.querySelectorAll('.popup-close-trigger');
    cancelButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.hide();
      });
    });

    const confirmButtons = this.wrapper.querySelectorAll('.popup-confirm-trigger');
    confirmButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.confirm();
      });
    });

    if (this.manual && this.wrapper.id) {
      const selector = `[data-open-popup="#${this.wrapper.id}"]`;
      document.querySelectorAll(selector).forEach((opener) => {
        opener.addEventListener('click', (event) => {
          event.preventDefault();
          this.show();
        });
      });
    }

    this.wrapper.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.wrapper.classList.contains('active')) {
        this.hide();
      }
    });
  }
}

function initPopupMessages(root = document) {
  root.querySelectorAll('.popup-message-wrapper').forEach((wrapper) => {
    if (wrapper.dataset.popupInitialized === 'true') return;
    wrapper.dataset.popupInitialized = 'true';
    new PopupMessage(wrapper);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initPopupMessages();
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initPopupMessages(event.target);
  });
}
